<template>
  <div class="GlslShader">
    <canvas id="canvas" ref="canvas" class="canvas" :class="{ show: ready }"/>  
  </div>
</template>

<script>

import Settings from '@/config/Settings'
import * as THREE from 'three'
import * as BAS from 'three-bas'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import OrbitControls from 'three-orbitcontrols'
import Animation from './Animation.js'
import gsap from "gsap"
import { Vertex, Fragment } from './shaders/GlslShader.js'
// import { Vertex, Fragment } from './shaders/ShaderThree.js'

import * as dat from 'dat-gui'

export default {
  name: 'GlslShader',
  props: ['indice'],
  data: ()=>({
    ready: true,
    is_loaded: false,
    exposure: 1,

    settings: {
      // vertex
      uFrequency: {
        start: 0,
        end: 4
      },
      uAmplitude: {
        start: 0,
        end: 4
      },
      uDensity: {
        start: 0,
        end: 4
      },
      uStrength: {
        start: 0,
        end: 1.1
      },
      // fragment
      uDeepPurple: {  // max 1
        start: 1,
        end: 0
      },
      uOpacity: {  // max 1
        start: .1,
        end: 1
      },
      time: { value: 1.0 }

      
    },

    density: 0,
    amplitude: 0,
    frequency: 0,
    u2Frequency: 70.00,
    u2Size: 40.00,
    u2Line: 400.00,
    u2SL: 200.00,
    brightness: .1,
    contrast: .1,
    oscilation: .5,


  }),
  beforeDestroy() {
  
  },

  mounted() {


    this.$gui = new dat.GUI() 
    this.$gui.domElement.style.marginTop = "10px"
    this.$gui.domElement.id = "datGUI"

    this.$scene = new THREE.Scene()
    this.$scene.background = new THREE.Color( 0x000000 ); // UPDATED
    this.$clock = new THREE.Clock()

    this.$renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true })
    this.$renderer.setSize(window.innerWidth,window.innerHeight)
    this.$renderer.setPixelRatio( window.devicePixelRatio )

    // this.$renderer.toneMapping = THREE.ACESFilmicToneMapping
    // this.$renderer.toneMappingExposure =  Math.pow( this.exposure, 4.0 );
    // this.$renderer.outputEncoding = THREE.sRGBEncoding

    // this.$ambient = new THREE.AmbientLight( 0xffffff, 100, 100 )
    // this.$scene.add( this.$ambient )

    this.$camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 10 )
    // this.$camera.position.set(0, .5, .3)
    this.$camera.position.set(0, 0, 2.5)
    // this.$camera.lookAt( 0, 0, 0 )

    this.$controls = new OrbitControls(this.$camera, this.$renderer.domElement)
    this.$controls.enableDamping = true
    this.$controls.dampingFactor = 0.25
    this.$controls.enableZoom = false

    // this.$uniforms = { time: { value: 1.0 } }

    // const geometry = new THREE.BoxGeometry(2, 2, 2)

    // const material = new THREE.ShaderMaterial( {
    //   uniforms: this.$uniforms,
    //   vertexShader: Vertex,
    //   fragmentShader: Fragment,
    // })

    const geometry = new THREE.IcosahedronGeometry(1, 64) 
    // const geometry = new THREE.SphereGeometry( 1, 16, 256 )
    // const geometry = new THREE.BoxGeometry( 1, 1, 1, 256, 256 );

    // const geometry = new THREE.PlaneGeometry(3, 3, 1024, 512);

    // const vertices = [
    //   -1,-1,-1,  1,-1,-1,  1, 1,-1,  -1, 1,-1,
    //   -1,-1, 1,  1,-1, 1,  1, 1, 1,  -1, 1, 1,
    // ]
    // const faces = [
    //   2,1,0,  0,3,2, 0,3,2, 
    //   0,4,7,  7,3,0,
    //   0,1,5,  5,4,0,
    //   1,2,6,  6,5,1,
    //   2,3,7,  7,6,2,
    //   4,5,6,  6,7,4
    // ]
    // const geometry = new THREE.PolyhedronGeometry(vertices, faces, 6, 2);


   

    // const material = new THREE.MeshBasicMaterial( {color: 0xdb2000, wireframe: false } )

    const material = new THREE.ShaderMaterial({
      wireframe: true,
      blending: THREE.AdditiveBlending,
      // transparent: true,
      vertexShader: Vertex,
      fragmentShader: Fragment,
      // uniforms: this.$uniforms,
      uniforms: {
        // time: { value: 1.0 },
        uFrequency: { value: this.settings.uFrequency.start },
        uAmplitude: { value: this.settings.uAmplitude.start },
        uDensity: { value: this.settings.uDensity.start },
        uStrength: { value: this.settings.uStrength.start },
        uDeepPurple: { value: this.settings.uDeepPurple.start },
        uOpacity: { value: this.settings.uOpacity.start },
        time: { value: this.settings.time },
        u2Frequency: { value: this.u2Frequency },
        u2Size: { value: this.u2Size },
        u2Line: { value: this.u2Line },
        u2SL: { value: this.u2SL },
        uBrightness: { value: this.brightness },
        uContrast: { value: this.contrast },
        uOscilation: { value: this.oscilation },
      }
    })

    this.$mesh = new THREE.Mesh( geometry, material )
    this.$scene.add( this.$mesh )

    window.addEventListener( 'resize', this.onWindowResize )
    this.ready = true

    this.$nextTick(()=>{
      this.render()

      gsap.to(this.$mesh.material.uniforms.uStrength, { value: 1.0, duration: 5, ease: 'cubic.easeOut', yoyo:true, repeat: -1 })

      const folder = this.$gui.addFolder('Settings')
            folder.add(this, 'density', 0, 4.0)
                  .onChange((v)=> { this.$mesh.material.uniforms.uDensity.value = v })
            folder.add(this, 'amplitude', 0, 4.0)
                  .onChange((v)=> { this.$mesh.material.uniforms.uAmplitude.value = v })
            folder.add(this, 'frequency', 0, 4.0)
                  .onChange((v)=> { this.$mesh.material.uniforms.uFrequency.value = v })  
            folder.add(this, 'u2Frequency', 0, 1000.0)
                  .onChange((v)=> { this.$mesh.material.uniforms.u2Frequency.value = v }) 


            folder.add(this, 'u2Size', 0, 400.0)
                  .onChange((v)=> { this.$mesh.material.uniforms.u2Frequency.value = v }) 

            folder.add(this, 'u2Line', 0, 800.0)
                  .onChange((v)=> { this.$mesh.material.uniforms.u2Line.value = v }) 

             folder.add(this, 'u2SL', 0, 400.0)
                  .onChange((v)=> { this.$mesh.material.uniforms.u2SL.value = v })   

            folder.add(this, 'brightness', 0, 1.0)
                  .onChange((v)=> { this.$mesh.material.uniforms.uBrightness.value = v })   

            folder.add(this, 'contrast', 0, 1.0)
                  .onChange((v)=> { this.$mesh.material.uniforms.uContrast.value = v }) 

             folder.add(this, 'oscilation', 0, 1.0)
                  .onChange((v)=> { this.$mesh.material.uniforms.uOscilation.value = v }) 


            folder.open()
    })

  },

  methods:{
    render(){ 


  
      const elapsedTime = this.$clock.getElapsedTime()
      this.$mesh.rotation.y = elapsedTime * .15

      this.$mesh.material.uniforms.time.value = performance.now() / 1000
     

      this.$controls.update()
      this.$renderer.render(this.$scene, this.$camera)
      window.requestAnimationFrame(this.render) 
      
    },

    onWindowResize() {
      this.$camera.aspect = window.innerWidth / window.innerHeight
      this.$camera.updateProjectionMatrix()
      this.$renderer.setSize( window.innerWidth, window.innerHeight )
    },
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.GlslShader
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden  
 
  canvas
    width 100%
    height 100%
    opacity 0
    transition opacity .5s
    transition-delay 1

    &.show 
      opacity 1

  &__container
     width 100%
     position relative
     container-height(2)

</style>


